import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import ChartView from '../views/chartView.vue';
import Post from '../views/PostView.vue';
import Login from "@/views/LoginView";
import store from "../store";
import workshopUser from "@/views/workshopUser";
import WorkshopView from "@/views/workshopView.vue";
import WorkshopNotice from "@/views/workshopNotice.vue";
import TaskConfigView from "@/views/TaskConfigView.vue"; // Importiere die ConfigView
import TaskView from "@/views/TaskView.vue"; // Importiere die TaskView

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/chart',
    name: 'Chart',
    component: ChartView,
    meta: { requiresAuth: false }
  },
  {
    path: '/customer/:customerId/workshop/:id',
    name: 'Workshop',
    component: WorkshopView,
    meta: { requiresAuth: false }
  },
  {
    path: '/customer/:customerId/workshop/:id/notice',
    name: 'Notice',
    component: WorkshopNotice,
    meta: { requiresAuth: false }
  },
  {
    path: '/post/:id',
    name: 'Post',
    component: Post,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/customer/:customerId/workshop/join/:workshopId/:lang',
    name: 'WorkshopUser',
    component: workshopUser,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/customer/:customerId/config',
    name: 'Config',
    component: TaskConfigView,
    meta: { requiresAuth: false }, // Optional, falls Authentifizierung erforderlich ist
  },
  {
    path: '/customer/:customerId/workshop/:id/tasks',
    name: 'Tasks',
    component: TaskView,
    meta: { requiresAuth: false } // Aufgabenübersicht benötigt Authentifizierung
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !store.getters.currentUser) {
    store.dispatch('fetchUser').then(() => {
      if (!store.getters.currentUser) {
        next('/login');
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

export default router;
